export default {
    models: [
        'group',
        'schedule',
        'schedule-entry',
        'subject',
        'survey',
        'article',
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/js/forms.js